/* import __COLOCATED_TEMPLATE__ from './base-banner.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import type RouterService from '@ember/routing/router-service';

interface Args {
  onDismiss: () => void;
  ctaEventObject: string;
  dismissEventObject: string;
  bannerType: string;
  titleKey: string;
  ctaKey: string;
  containerClass: string;
}

export default class BaseBanner extends Component<Args> {
  @service declare intercomEventService: $TSFixMe;
  @service declare router: RouterService;
  @service declare appService: $TSFixMe;

  @tracked isUsageDrawerOpen = false;

  get location(): string {
    return this.router.currentRouteName || '';
  }

  get appId(): string {
    return this.appService.app.id;
  }

  @action
  onCtaClick() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: this.args.ctaEventObject,
      place: this.location,
    });

    this.isUsageDrawerOpen = true;
  }

  @action
  onUsageDrawerOpenChange(isOpen: boolean) {
    this.isUsageDrawerOpen = isOpen;
  }

  @action
  handleDismiss() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'dismissed',
      object: this.args.dismissEventObject,
      place: this.location,
    });

    this.args.onDismiss();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinUsageGlobalBanners::BaseBanner': typeof BaseBanner;
    'fin-usage-global-banners/base-banner': typeof BaseBanner;
  }
}
